module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', [_c('website', {
    ref: "website"
  }), _vm._v(" "), _c('div', {
    staticClass: "page section-header text-center"
  }, [_c('h1', [_vm._v(_vm._s(_vm.displayItemList[0].groupName))])]), _vm._v(" "), _c('div', {
    staticClass: "page-width"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "row p-mt-3"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('h6', [_vm._v("FILTER BY SIZE")]), _vm._v(" "), _c('div', {
    staticClass: "p-field-checkbox"
  }, [_c('Checkbox', {
    attrs: {
      "name": "city",
      "value": "Chicago"
    },
    model: {
      value: (_vm.cities),
      callback: function($$v) {
        _vm.cities = $$v
      },
      expression: "cities"
    }
  }), _vm._v(" "), _c('label', [_vm._v("3-4 Yrs")])], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field-checkbox"
  }, [_c('Checkbox', {
    attrs: {
      "name": "city",
      "value": "Los Angeles"
    },
    model: {
      value: (_vm.cities),
      callback: function($$v) {
        _vm.cities = $$v
      },
      expression: "cities"
    }
  }), _vm._v(" "), _c('label', [_vm._v("4-5 Yrs")])], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field-checkbox"
  }, [_c('Checkbox', {
    attrs: {
      "name": "city",
      "value": "New York"
    },
    model: {
      value: (_vm.cities),
      callback: function($$v) {
        _vm.cities = $$v
      },
      expression: "cities"
    }
  }), _vm._v(" "), _c('label', [_vm._v("5-6 Yrs")])], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field-checkbox"
  }, [_c('Checkbox', {
    attrs: {
      "name": "city",
      "value": "San Francisco"
    },
    model: {
      value: (_vm.cities),
      callback: function($$v) {
        _vm.cities = $$v
      },
      expression: "cities"
    }
  }), _vm._v(" "), _c('label', [_vm._v("7-8 Yrs")])], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field-checkbox"
  }, [_c('Checkbox', {
    attrs: {
      "name": "city",
      "value": "San Francisco"
    },
    model: {
      value: (_vm.cities),
      callback: function($$v) {
        _vm.cities = $$v
      },
      expression: "cities"
    }
  }), _vm._v(" "), _c('label', [_vm._v("8-10 Yrs")])], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field-checkbox"
  }, [_c('Checkbox', {
    attrs: {
      "name": "city",
      "value": "San Francisco"
    },
    model: {
      value: (_vm.cities),
      callback: function($$v) {
        _vm.cities = $$v
      },
      expression: "cities"
    }
  }), _vm._v(" "), _c('label', [_vm._v("10-12 Yrs")])], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field-checkbox"
  }, [_c('Checkbox', {
    attrs: {
      "name": "city",
      "value": "San Francisco"
    },
    model: {
      value: (_vm.cities),
      callback: function($$v) {
        _vm.cities = $$v
      },
      expression: "cities"
    }
  }), _vm._v(" "), _c('label', [_vm._v("12-14 Yrs")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "filters-toolbar__item filters-toolbar__item--count"
  }, [_c('span', {
    staticClass: "filters-toolbar__product-count"
  }, [_vm._v("\n            \t\n            \t\tShowing: " + _vm._s(_vm.displayItemList.length) + "\n            \t\n        \t")])]), _vm._v(" "), _c('DataView', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value": _vm.displayItemList,
      "paginator": false,
      "lazy": true,
      "rows": 200,
      "layout": _vm.layout
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "p-grid p-nogutter",
          staticStyle: {
            "margin": "0% 0% 0% 90%"
          }
        }, [_c('div', {
          staticClass: "p-col-6",
          staticStyle: {
            "text-align": "left"
          }
        }, [_c('Dropdown', {
          attrs: {
            "options": _vm.sortOptions,
            "optionLabel": "label",
            "placeholder": "Sort"
          },
          on: {
            "change": function($event) {
              return _vm.onSortChange($event)
            }
          },
          model: {
            value: (_vm.sortKey),
            callback: function($$v) {
              _vm.sortKey = $$v
            },
            expression: "sortKey"
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "p-col-6",
          staticStyle: {
            "margin": "0% -942%"
          }
        }, [_c('DataViewLayoutOptions', {
          staticClass: "filters-toolbar__item collection-view-as"
        })], 1)])]
      },
      proxy: true
    }, {
      key: "grid",
      fn: function(slotProps) {
        return [_c('div', {
          staticClass: "p-col-12 p-md-3",
          staticStyle: {
            "border-bottom": "0px solid #c8c8c8"
          }
        }, [_c('div', {
          staticClass: "productList"
        }, [_c('div', {
          staticClass: "grid__item small--one-half medium--one-third large-up--one-quarter"
        }, [_c('div', {
          staticClass: "grid-view-item style1 wow fadeIn"
        }, [_c('div', {
          staticClass: "grid-view_image"
        }, [_c('a', {
          attrs: {
            "href": ""
          }
        }, [_c('img', {
          staticStyle: {
            "height": "300px",
            "width": "85%"
          },
          attrs: {
            "src": slotProps.data.singleImageUrl,
            "alt": slotProps.data.name
          },
          on: {
            "click": function($event) {
              return _vm.viewProductDetailsPage(slotProps.data)
            }
          }
        })])]), _vm._v(" "), _c('div', {
          staticClass: "grid-view-item__title"
        }, [_vm._v(_vm._s(slotProps.data.name))]), _vm._v(" "), _c('span', {
          staticClass: "product-price__price"
        }, [_vm._v("Nrs." + _vm._s(slotProps.data.salesRate))]), _vm._v(" "), _c('div', {
          staticClass: "product-description"
        }, [_vm._v(_vm._s(slotProps.data.description))])])])])])]
      }
    }, {
      key: "list",
      fn: function(slotProps) {
        return [_c('div', {
          staticClass: "p-col-12 p-md-1",
          staticStyle: {
            "border-bottom": "0px solid #c8c8c8"
          }
        }, [_c('div', {
          staticClass: "product-list-item"
        }, [_c('div', {
          staticClass: "list__item small--one-half medium--one-third large-up--one-quarter"
        }, [_c('div', {
          staticClass: "list-view-item style1 wow fadeIn"
        }, [_c('div', {
          staticClass: "product-list-detail"
        }, [_c('a', {
          attrs: {
            "href": ""
          }
        }, [_c('img', {
          staticStyle: {
            "height": "300px",
            "width": "85%"
          },
          attrs: {
            "src": slotProps.data.singleImageUrl,
            "alt": slotProps.data.name
          },
          on: {
            "click": function($event) {
              return _vm.viewProductDetailsPage(slotProps.data)
            }
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "list-view-item__title"
        }, [_vm._v(_vm._s(slotProps.data.name))]), _vm._v(" "), _c('span', {
          staticClass: "product-price__price"
        }, [_vm._v("Nrs." + _vm._s(slotProps.data.salesRate))]), _vm._v(" "), _c('div', {
          staticClass: "product-description"
        }, [_vm._v(_vm._s(slotProps.data.description))])])])])])])]
      }
    }])
  })], 1)])])]), _vm._v(" "), _c('footerWebsite', {
    ref: "footerWebsite"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-760760f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ecommerce/collections.vue
// module id = 2323
// module chunks = 0